import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api/api.service';
import { AddProgramRequestBodyI } from './interfaces/add-program-request-body.interface';
import { EditProgramRequestBodyI } from './interfaces/edit-program-request-body.interface';
import { FilterProgramsI } from './interfaces/filter-programs.interface';
import { ProgramI } from './interfaces/program.interface';
import { DeleteProgramRequestQuery } from './interfaces/delete-program-request-query.interface';

@Injectable({
  providedIn: 'root',
})
export class ProgramsApiService {
  constructor(private readonly apiService: ApiService) {}

  findAllForFaculty(facultyID: string, filterPrograms: FilterProgramsI) {
    return this.apiService.get<ProgramI[]>(
      `programs/faculties/${facultyID}`,
      filterPrograms
    );
  }
  findAllForDepartment(departmentID: string, filterPrograms: FilterProgramsI) {
    return this.apiService.get<ProgramI[]>(
      `programs/departments/${departmentID}`,
      filterPrograms
    );
  }
  findAll(filterPrograms: FilterProgramsI) {
    return this.apiService.get<ProgramI[]>('programs', filterPrograms);
  }

  count() {
    return this.apiService.get<number>('programs/count');
  }

  findOne(programID: string) {
    return this.apiService.get<ProgramI>(`programs/${programID}`);
  }

  addProgram(addProgramRequestBody: AddProgramRequestBodyI, facultyID: string) {
    return this.apiService.post<ProgramI>(
      `programs/${facultyID}`,
      addProgramRequestBody
    );
  }

  editProgram(
    programID: string,
    editProgramRequestBody: EditProgramRequestBodyI
  ) {
    return this.apiService.put<ProgramI>(
      `programs/${programID}`,
      editProgramRequestBody
    );
  }

  deleteProgram(
    programID: string,
    deleteProgramRequestQuery: DeleteProgramRequestQuery
  ) {
    return this.apiService.delete<ProgramI>(
      `programs/${programID}`,
      deleteProgramRequestQuery
    );
  }
}
